<template>
    <v-card rounded="t-xl">
      <v-expansion-panels>
        <v-expansion-panel
          v-for="i in $store.state.info.faqs"
          :key="i.id"
        >
          <v-expansion-panel-title>{{i.question}}</v-expansion-panel-title>
          <v-expansion-panel-text class="px-3 py-2 text-justify">
            <p v-html="(i.answer || '').replaceAll('\n','<br/>')"></p>
            <v-btn v-if="!!i.file && i.file.length > 0" :href="i.file" size="small" elevation="5" color="primary" class="mt-3">
              دانلود پیوست
            </v-btn>
          </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
    </v-card>
  </template>
  
  <script>
  
  export default {
    name: "FaqsList",
    data() {
      return {
      }
    },
    methods: {
      
    },
  }
  </script>

  